module.exports = __webpack_public_path__ + "assets/img/logo-fizy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-fizy.svg
// module id = 110
// module chunks = 0